import {
  NOTIFICATION_CONFIG,
  NOTIFICATION_CONFIG_START,
  NOTIFICATION_CONFIG_DATA,
  NOTIFICATION_CONFIG_END,
  NOTIFICATION_CONFIG_GETBY,
  NOTIFICATION_CONFIG_CREATE,
  NOTIFICATION_CONFIG_UPDATE,
  NOTIFICATION_CONFIG_DELETE,
} from "../../slices/type";

interface InitState {
  data: any[];
  dataSingle: any[];
  getByID: any;
  create: any[];
  update: any[];
  delete: any[];
  loading: boolean;
}

const initState: InitState = {
  data: [],
  dataSingle: [],
  getByID: {},
  create: [],
  update: [],
  delete: [],
  loading: false,
};

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const NotificationConfig_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case NOTIFICATION_CONFIG_START:
      return {
        ...state,
        loading: action.loading ?? false,
      };
    case NOTIFICATION_CONFIG_DATA:
      return {
        ...state,
        data: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case NOTIFICATION_CONFIG_GETBY:
      return {
        ...state,
        getByID: action.payload ?? {},
        loading: action.loading ?? false,
      };
    case NOTIFICATION_CONFIG_CREATE:
      return {
        ...state,
        create: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case NOTIFICATION_CONFIG_UPDATE:
      return {
        ...state,
        update: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case NOTIFICATION_CONFIG_DELETE:
      return {
        ...state,
        delete: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case NOTIFICATION_CONFIG_END:
      return {
        ...state,
        dataSingle: action.payload ?? [],
        loading: action.loading ?? false,
      };
    default:
      return state;
  }
};

export default NotificationConfig_Red;
